'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import  {ExperienceCenterLocationSpecificProps} from 'components/commercetools-ui/organisms/experience-center/location-specific';
import OurStoryPage from 'components/commercetools-ui/organisms/our-story';


const OurStoryPageTastic  = ({ data }: TasticProps<ExperienceCenterLocationSpecificProps>) => {
  
    
  return <OurStoryPage data={data?.data?.dataSource} />;
};

export default OurStoryPageTastic;